import Editor from './base/editor';
import focusInput from '@intercom/embercom-composer/lib/focus-input';
import BlockAlignment from './mixins/block-alignment';
import $ from 'jquery';
import { alias, reads } from '@ember/object/computed';
import { schedule } from '@ember/runloop';
import Em from 'ember';
export default Editor.extend(BlockAlignment, {
  keysToTriggerClose: [9, 13, 27],
  keepSelectedOnDismiss: true,
  classNames: ['is-light-theme', 'composer-image-editor'],
  classNameBindings: ['isEditMode:composer-editor-is-active'],
  hasLink: reads('editableObject.hasLinkUrl'),
  isCentered: alias('editableObject.isCentered'),
  isEditMode: false,
  dimensionsChanged: Em.observer({
    dependentKeys: ['isEditMode'],
    fn() {
      schedule('afterRender', this, this.setupEditorDimensions);
    },
    sync: false
  }),
  actions: {
    editLink() {
      this.set('isEditMode', true);
      schedule('afterRender', this, function () {
        focusInput($('input', this.element));
      });
    },
    delete() {
      this.set('editableObject.linkUrl', null);
      this.set('isEditMode', false);
    },
    dismiss() {
      if (!this.get('isDestroying')) {
        this.set('isEditMode', false);
      }
      this.cleanData();
      this.deleteEntityIfPropertyBlank();
    }
  }
});